import { render, staticRenderFns } from "./supplierList.vue?vue&type=template&id=59d697f8&scoped=true&"
import script from "./supplierList.vue?vue&type=script&lang=js&"
export * from "./supplierList.vue?vue&type=script&lang=js&"
import style0 from "./supplierList.vue?vue&type=style&index=0&id=59d697f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d697f8",
  null
  
)

export default component.exports